export class CommentLike {
    id:any;
    userId:string | undefined;
    commentId:string | undefined;
    like:number | undefined;
    likeNew:number | undefined;
}
